var map = {
	"./change-password/sagas.js": "./src/change-password/sagas.js",
	"./cognito-redux/sagas.js": "./src/cognito-redux/sagas.js",
	"./forgot-password/sagas.js": "./src/forgot-password/sagas.js",
	"./login/sagas.js": "./src/login/sagas.js",
	"./register/sagas.js": "./src/register/sagas.js",
	"./verify/sagas.js": "./src/verify/sagas.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src recursive sagas.js";


//////////////////
// WEBPACK FOOTER
// ./src sagas.js
// module id = ./src recursive sagas.js
// module chunks = 1